export default class AGnftFilter {}
